<div class="layout-dashboard">
    <div class="grid">
        <div class="col-12 xl:col-12">
            <div class="card mx-1 bg-card">
                <div
                    class="flex w-full justify-content-between align-items-start mb-2"
                >
                <div class="flex align-items-start gap-3">
                    <img class="title-image" *ngIf="getDeviceType()==='desktop' || getDeviceType()==='desktop'; else mobileIcon" src="../../../../assets/demo/images/car-insurance-img.gif">
                    <ng-template #mobileIcon>
                        <img class="title-image mobile-icon" src="../../../../assets/demo/images/car-insurance-img.gif">
                    </ng-template>
                    <div class="flex flex-column pt-1">
                        <h5 class="mb-0 pb-0">{{ "VEHICLES" | translate }}</h5>
                        <small class="list-stats">{{vehiclesPendingDocumentsCount}} {{'with pending documents' | translate}}</small>
                    </div>
                </div>
                    <button *ngIf="getDeviceType()==='desktop' || getDeviceType()==='tablet'"
                        type="button"
                        pButton
                        class="p-button p-button-primary add-button"
                        icon="pi pi-plus"
                        [label]="'ADD_VEHICLE' | translate"
                        (click)="navigateToAddVehicle()"
                    ></button>
                    <button *ngIf="getDeviceType()==='mobile'" type="button"
                            pButton
                            pRipple
                            pTooltip="Add new driver"
                            class="p-button p-button-primary add-button"
                            icon="pi pi-plus"
                            (click)="navigateToAddVehicle()"></button>
                </div>
                <div class="spacer"></div>
                <p-table
                    [value]="vehicles"
                    [paginator]="true"
                    [rows]="10"
                    *ngIf="(getDeviceType()==='desktop' || getDeviceType()==='tablet')"
                    responsiveLayout="scroll"
                >
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{ "VRN" | translate }}</th>
                            <th>{{ "MODEL" | translate }}</th>
                            <th>{{ "WEIGHT_CATEGORY" | translate }}</th>
                            <th>{{ "VEHICLE_USAGE" | translate }}</th>
                            <th>{{ "CARRYING_CAPACITY" | translate }}</th>
                            <th>{{ "VEHICLE_VALUE" | translate }}</th>
                            <th>{{ "STATUS" | translate }}</th>
                            <th>{{ "ACTIONS" | translate }}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-vehicle>
                        <tr [ngClass]="rowClass(vehicle)" >
                            <td>
                                <span class="p-column-title">VRN</span>
                                {{ vehicle.registrationNumber }}
                            </td>
                            <td>
                                <span class="p-column-title">Model</span>
                                {{ vehicle.model.make.name }} /
                                {{ vehicle.model.name }} /
                                {{ vehicle.yearOfManufacture }}
                            </td>
                            <td>
                                <span class="p-column-title"
                                    >Weight Category</span
                                >
                                {{ vehicle.weightCategory.name | translate }}
                            </td>
                            <td>
                                <span class="p-column-title">Use</span>
                                {{ vehicle.vehicleUse.description | translate }}
                            </td>
                            <td>
                                <span class="p-column-title"
                                    >Carrying Capacity</span
                                >
                                {{ vehicle.carryingCapacity }}
                            </td>
                            <td>
                                <span class="p-column-title"
                                    >Vehicle Value</span
                                >
                                {{
                                    vehicle.vehicleValue
                                        | currency : "MZN" + " "
                                }}
                            </td>
                            <td>
                                <span class="p-column-title">Status</span>
                                {{ vehicle.status | translate }}
                            </td>
                            <td>
                                <p-button
                                    class="table-button"
                                    [pTooltip]="
                                        'VIEW_VEHICLE_DETAILS' | translate
                                    "
                                    icon="pi pi-info-circle"
                                    [pTooltip]=""
                                    [rounded]="true"
                                    [text]="true"
                                    (click)="viewDetails(vehicle.id)"
                                    severity="info"
                                />
                                <p-button
                                    *ngIf="false"
                                    (click)="delete(vehicle.id)"
                                    class="table-button delete-driver"
                                    [pTooltip]="'DELETE_VEHICLE' | translate"
                                    icon="pi pi-trash"
                                    [rounded]="true"
                                    [text]="true"
                                    [style]="{ 'background-color': 'white' }"
                                    severity="danger"
                                />
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                <ng-container *ngIf="getDeviceType() === 'mobile'" >
                    <div class="vehicle-tiles-container">
                        <div class="vehicle-item-container flex flex-column">
                            <app-vehicle-list-card *ngFor="let vehicle of vehicles" class="my-2" [vehicle]="vehicle" (click)="viewDetails(vehicle.id)"></app-vehicle-list-card>

                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
